import CustomStore from 'devextreme/data/custom_store';
import { ref, reactive } from 'vue';
import useDomainClientRepository from '@/modules/masterData/clientDomainClients/repositories/domainClient.repository.js';
import store from '@/store/index';

export default function useDatagrid(clientId) {
  const domainClientRepository = useDomainClientRepository(clientId);
  const datasource = ref();
  const domainClients = ref([]);
  const clientList = reactive({ data: [] });

  // Full (unpaged) list, used to exclude already added clients in the add form
  const loadDomainClients = () => domainClientRepository.loadAll()
    .then((response) => {
      if (response.data.success) {
        domainClients.value = response.data.value || [];
        return domainClients.value;
      }
      if (response.data.messages && response.data.messages.length > 0) {
        store.dispatch('addNotifications', { messageList: response.data.messages });
      }
      return [];
    });

  const loadClients = () => domainClientRepository.getClients()
    .then((response) => {
      clientList.data = response.data || [];
    });

  const getDatasource = () => {
    datasource.value = new CustomStore({
      key: 'clientId',
      load: (loadOptions) => domainClientRepository.load(loadOptions)
        .then((response) => ({
          data: response.data.data,
          totalCount: response.data.totalCount,
          summary: response.data.summary,
          groupCount: response.data.groupCount,
        })),
      remove: (key) => new Promise((resolve, reject) => {
        domainClientRepository.remove(key)
          .then((response) => {
            if (response.data.success) {
              store.dispatch('addSuccessNotification', 'Domæne pengeinstitut er nu fjernet');
              loadDomainClients();
              resolve(response);
            } else {
              if (response.data.messages && response.data.messages.length > 0) {
                store.dispatch('addNotifications', { messageList: response.data.messages });
              }
              reject();
            }
          });
      }),
    });
  };

  const addDomainClient = (domainClientId) => domainClientRepository.add(domainClientId)
    .then((response) => {
      if (response.data.success) {
        store.dispatch('addSuccessNotification', 'Domæne pengeinstitut er nu tilføjet');
        loadDomainClients();
        return true;
      }
      if (response.data.messages && response.data.messages.length > 0) {
        store.dispatch('addNotifications', { messageList: response.data.messages });
      }
      return false;
    });

  return {
    datasource,
    domainClients,
    clientList,
    getDatasource,
    loadDomainClients,
    loadClients,
    addDomainClient,
  };
}
